import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect } from 'react';
import { useAuth } from 'react-oidc-context';
import { useNavigate } from 'react-router-dom';
/**
 * AuthCallback — handles the OIDC authorization code redirect callback.
 * Mounted at `/auth/callback` in the portal router.
 *
 * react-oidc-context automatically processes the callback when this component
 * mounts (it calls UserManager.signinRedirectCallback() internally).
 * On success, we navigate to state.returnTo or '/'.
 * On error, we render a non-technical error page (no OAuth error details shown).
 */
export function AuthCallback() {
    const auth = useAuth();
    const navigate = useNavigate();
    useEffect(() => {
        if (!auth.isLoading && auth.isAuthenticated) {
            const state = auth.user?.state;
            const returnTo = typeof state?.returnTo === 'string' ? state.returnTo : '/';
            void navigate(returnTo, { replace: true });
        }
    }, [auth.isLoading, auth.isAuthenticated, auth.user?.state, navigate]);
    if (auth.error) {
        return (_jsx("div", { role: "main", className: "flex min-h-screen items-center justify-center", children: _jsxs("div", { className: "text-center", children: [_jsx("h1", { className: "text-2xl font-semibold text-gray-900", children: "Sign-in could not be completed" }), _jsxs("p", { className: "mt-2 text-gray-600", children: ["There was a problem signing you in. Please try again.", _jsx("br", {}), "If the problem persists, contact", ' ', _jsx("a", { href: "mailto:support@nourishedrx.com", className: "text-blue-600 underline", children: "NourishedRx support" }), "."] })] }) }));
    }
    return (_jsx("div", { role: "status", "aria-label": "Completing sign-in...", className: "flex min-h-screen items-center justify-center", children: _jsx("div", { className: "text-center text-gray-500", children: "Completing sign-in\u2026" }) }));
}
//# sourceMappingURL=auth-callback.js.map